module.exports = __webpack_public_path__ + "img/Journalisma7.20a6fcdf.png";